const loadForm = async (fileName: string) => {
    return new Promise<void>((resolve, reject) => {
        const existingScript = document.querySelector(
            `script[src="/wp-content/themes/touchbistro4/js/${fileName}.js"]`
        );

        if (existingScript) {
            resolve();
            return;
        }

        const script = document.createElement('script');
        script.src = `/wp-content/themes/touchbistro4/js/${fileName}.js`;
        script.async = true;

        script.onload = () => {
            resolve();
        };

        script.onerror = () => {
            reject(new Error(`Failed to load script: ${fileName}.js`));
        };
        document.body.appendChild(script);
    });
};

export default loadForm;
